import Cookie from '@component/common/src/util/Cookie';

const MACYS_BAGGUID = 'macys_bagguid';
const MACYS_ONLINE_UID = 'macys_online_uid';

export default {
  getUrl() {
    const RESPONSIVE_QUICK_BAG_URL = '/xapi/bag/v1/quickbag/';
    const MACYS_BAGGUID_COOKIE = Cookie.get(MACYS_BAGGUID);
    if (MACYS_BAGGUID_COOKIE) {
      return `${RESPONSIVE_QUICK_BAG_URL}${MACYS_BAGGUID_COOKIE}`;
    }
    return `${RESPONSIVE_QUICK_BAG_URL}user/${Cookie.get(MACYS_ONLINE_UID)}`;
  },
};
